const arMessages = {
  upload: {
      cancel: 'إلغاء',
      clearSelectedFiles: 'مسح',
      dropFilesHere: 'اسحب ملفاتك هنا',
      headerStatusUploaded: 'مكتمل',
      headerStatusUploading: 'جاري الرفع...',
      invalidFileExtension: 'نوع الملف هذا غير مسموح للرفع.',
      invalidFiles: 'ملفات غير صالحة. يرجى التحقق من متطلبات الرفع.',
      invalidMaxFileSize: 'الملف كبير جداً.',
      invalidMinFileSize: 'الملف صغير جداً.',
      remove: 'إزالة',
      retry: 'إعادة المحاولة',
      select: 'اختر الملفات...',
      uploadSelectedFiles: 'رفع',
      total: 'المجموع',
      files: 'ملفات',
      selectTitle: 'انقر لاختيار المزيد من الملفات',
      selectNoFilesTitle: 'لا توجد ملفات مختارة',
      statusUploaded: 'تم رفع الملفات بنجاح.',
      statusUploadFailed: 'فشل في رفع الملف(ات).',
      dropZoneHint: 'اسحب الملفات هنا لرفعها.',
      defaultDropZoneNote: '',
      dropZoneNote: 'يُسمح فقط بـ {0} ملف.'
  }
};
export default arMessages;
